<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addContactFunction></addContactFunction>
    </v-dialog>

</template>

<script>
    import {ContactFunctionsSettings} from '../../../store/namespace-helper'

    import addContactFunction from '../../Shared/AddContactFunction.vue'

    export default {
      name: 'add-new-contact-function-dialog',
      components: {
        addContactFunction
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[ContactFunctionsSettings.getters.getOpenNewContactFunctionDialogState]
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/ContactFunctions/AddContactFunctionDialog.vue